// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #0f1226;
}

.brand-loader-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(135deg, #1e1b4b 0%, #0f1226 50%, #102a3a 100%);
}

.brand-loader .blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.55;
  will-change: transform;
}

.brand-loader .blob-1 {
  width: 480px; height: 480px;
  background: radial-gradient(circle, #3b82f6, transparent 70%);
  top: -120px; left: -100px;
  animation: drift1 18s ease-in-out infinite;
}
.brand-loader .blob-2 {
  width: 420px; height: 420px;
  background: radial-gradient(circle, #06b6d4, transparent 70%);
  bottom: -140px; right: -80px;
  animation: drift2 22s ease-in-out infinite;
}
.brand-loader .blob-3 {
  width: 380px; height: 380px;
  background: radial-gradient(circle, #0ea5e9, transparent 70%);
  top: 40%; left: 50%;
  animation: drift3 20s ease-in-out infinite;
}

@keyframes drift1 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(120px, 80px) scale(1.15); }
}
@keyframes drift2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(-100px, -90px) scale(1.1); }
}
@keyframes drift3 {
  0%, 100% { transform: translate(-50%, 0) scale(1); }
  50%      { transform: translate(-50%, -70px) scale(1.2); }
}

.brand-loader-text {
  position: relative;
  z-index: 1;
  font-size: 38px;
  font-weight: 700;
  letter-spacing: -0.5px;

  background: linear-gradient(90deg, #3b82f6, #06b6d4, #0ea5e9, #06b6d4, #3b82f6);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shimmer 4s linear infinite, fadeIn 0.6s ease-out backwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes shimmer {
  0%   { background-position: 0% 0; }
  100% { background-position: 200% 0; }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Loaders/BrandLoader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,WAAW,EAAE,YAAY;EACzB,0CAA0C;AAC5C;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,cAAc,EAAE,YAAY;EAC5B,0CAA0C;AAC5C;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,QAAQ,EAAE,SAAS;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,6CAA6C,EAAE;AAC5D;AACA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,8CAA8C,EAAE;AAC7D;AACA;EACE,WAAW,sCAAsC,EAAE;EACnD,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;;EAEtB,+EAA+E;EAC/E,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,qEAAqE;AACvE;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,yBAAyB,EAAE;EAClC,OAAO,2BAA2B,EAAE;AACtC","sourcesContent":[".brand-loader {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #0f1226;\n}\n\n.brand-loader-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background: linear-gradient(135deg, #1e1b4b 0%, #0f1226 50%, #102a3a 100%);\n}\n\n.brand-loader .blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.55;\n  will-change: transform;\n}\n\n.brand-loader .blob-1 {\n  width: 480px; height: 480px;\n  background: radial-gradient(circle, #3b82f6, transparent 70%);\n  top: -120px; left: -100px;\n  animation: drift1 18s ease-in-out infinite;\n}\n.brand-loader .blob-2 {\n  width: 420px; height: 420px;\n  background: radial-gradient(circle, #06b6d4, transparent 70%);\n  bottom: -140px; right: -80px;\n  animation: drift2 22s ease-in-out infinite;\n}\n.brand-loader .blob-3 {\n  width: 380px; height: 380px;\n  background: radial-gradient(circle, #0ea5e9, transparent 70%);\n  top: 40%; left: 50%;\n  animation: drift3 20s ease-in-out infinite;\n}\n\n@keyframes drift1 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%      { transform: translate(120px, 80px) scale(1.15); }\n}\n@keyframes drift2 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%      { transform: translate(-100px, -90px) scale(1.1); }\n}\n@keyframes drift3 {\n  0%, 100% { transform: translate(-50%, 0) scale(1); }\n  50%      { transform: translate(-50%, -70px) scale(1.2); }\n}\n\n.brand-loader-text {\n  position: relative;\n  z-index: 1;\n  font-size: 38px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n\n  background: linear-gradient(90deg, #3b82f6, #06b6d4, #0ea5e9, #06b6d4, #3b82f6);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: shimmer 4s linear infinite, fadeIn 0.6s ease-out backwards;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes shimmer {\n  0%   { background-position: 0% 0; }\n  100% { background-position: 200% 0; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
